import React from "react";
import Classes from "../Dashboard.module.css";
import { useNavigate } from "react-router-dom";
import { XIcon } from "../../../../../../utils/Icons";

export default function WarningStrip({ handleCloseWarning }) {
    const navigateTo = useNavigate();

    return (
        <>
            <div className={Classes.trialStrip}>
                <h5>
                    ⚠️ Important: All mentee communication, scheduling, and payments must
                    remain on Mentr. Attempting to move sessions or payments off-platform
                    to avoid fees may result in account suspension or permanent removal.
                </h5>

                <button onClick={handleCloseWarning} style={{ background: 'none' }} >
                    <XIcon height='20px' fill='#F26A63' />
                </button>
            </div>
        </>
    );
}
